import React, { useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { useNavigate, useParams } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { Link } from "react-router-dom";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "../../assets/event.css";
import { toast } from "react-toastify";
import "../../assets/SwitchGroup.css";

const Event = (props) => {
  document.title = "Event - VUF";
  const { id } = useParams();
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [Locations, setLocations] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedCity, setSelectedCity] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedDistrict, setSelectedDistrict] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [selectedLocation, setSelectedLocation] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [bImage, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const StatusOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  const EventOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  const handleFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      if (id == null) {
        setState((prev) => ({ ...prev, eventBannerImage: file }));
      }
      const reader = new FileReader();
      setImage(file);
      reader.onloadend = () => {
        setState((prevState) => ({
          ...prevState,
          image: file, // The raw file object for the API
          imagePreview: setImagePreview(reader.result), // The string for the UI preview
        }));
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please upload an image file.");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const [state, setState] = useState({
    loading: false,
    errors: {},
    ResErrors: {},
    isRedirect: false,
    eventName: "",
    image: null,
    EventType: "",
    eventDescription: "",
    eventBannerImage: "",
    eventStartDate: "",
    eventEndDate: "",
    registrationStartDate: "",
    registrationEndDate: "",
    eventStartTime: "",
    eventEndTime: "",
    location: "",
    countries: [],
    stateList: [],
    districtList: [],
    CityList: [],
    MaxRegistration: 0,
    selectedCity: {},
    selectedCountry: {},
    selectedDistrict: {},
    selectedState: {},
    country: "",
    state: "",
    district: "",
    city: "",
    countryDataCode: "",
    stateCode: "",
    districtCode: "",
    cityCode: "",
    id: "",
    RegistrationOpen: false,
    IsProfileCompleted: "false",
    IsCanceledEvent: false,
  });
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: id ? "Edit Event" : "Add Event", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems(id ? "Edit Event" : "Add Event", breadcrumbItems);
  });
  useEffect(() => {
    if (id !== "" && id != null && id != undefined) {
      getEvent();
    } else {
      onGetLocationsList();
      onGetCountryList();
    }
  }, []);

  function getEvent() {
    setLoading(true);
    let urlPath = "event/eventdetails/" + id;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var dataRes = responseData.data;

          setState((prevState) => ({
            ...prevState, // Copy the existing state
            eventName: dataRes.eventName,
            name: dataRes.eventName,
            eventDescription: dataRes.eventDescription,
            eventBannerImage: dataRes.eventBannerImage,
            eventStartDate: moment(dataRes.eventStartDate).format("YYYY-MM-DD"),
            eventEndDate: moment(dataRes.eventEndDate).format("YYYY-MM-DD"),
            registrationStartDate: moment(dataRes.registrationStartDate).format("YYYY-MM-DD",),
            registrationEndDate: moment(dataRes.registrationEndDate).format("YYYY-MM-DD",),
            eventStartTime: dataRes.eventStartTime,
            eventEndTime: dataRes.eventEndTime,
            location: dataRes.location,
            EventType: dataRes.EventType,
            country: dataRes.country,
            state: dataRes.state,
            district: dataRes.district,
            city: dataRes.city,
            countryDataCode: dataRes.countryDataCode,
            stateCode: dataRes.stateCode,
            districtCode: dataRes.districtCode,
            cityCode: dataRes.cityCode,
            IsCanceledEvent: dataRes.IsCanceledEvent,
            MaxRegistration: dataRes.MaxRegistration,
            //RegistrationOpen: dataRes.RegistrationOpen === "true" ? "true" : "false",
            RegistrationOpen: dataRes.RegistrationOpen === true || dataRes.RegistrationOpen === "true",
            id: id,
            IsProfileCompleted: dataRes.IsProfileCompleted,
            IsEventFree: dataRes.IsFreeEvent,
          }));
          setSelectedLocation({
            ...responseData.location,
            label: responseData.location.name,
            value: responseData.location.place_id,
          });
          setSelectedCountry({ label: dataRes.country, value: 0 });
          setSelectedState({ label: dataRes.state, value: 0 });
          setSelectedDistrict({ label: dataRes.district, value: 0 });
          setSelectedCity({ label: dataRes.city, value: 0 });
          setTimeout(() => {
            onGetLocationsList();
            onGetCountryList();
          }, 0);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
        // setState({ loading: false });
      })
      .finally((final) => {
        // return setState({ isInvitingUser: false })
      });
  }

  function onGetLocationsList() {
    setLoading(true);
    let urlPath = "DynamicPage/entry-locations/";
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "data" in responseData) {
          const { data } = responseData;

          let loc = [];
          data.map((c, i) => {
            loc.push({ ...c, label: c.name, value: c.place_id });
          });
          const cot = [{ options: loc }];
          setLocations(cot);
        }
        setLoading(false);
      })
      .catch((error) => { })
      .finally((final) => { });
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) {
      return false;
    }
    const formData = new FormData();
    if (id != undefined) {
      formData.append("_id", id);
    }
    formData.append("eventName", state.eventName);
    formData.append("eventDescription", state.eventDescription);
    formData.append("location", state.location);
    formData.append("EventType", state.EventType);
    formData.append("country", selectedCountry.label);
    formData.append("state", selectedState.label);
    formData.append("district", selectedDistrict.label);
    formData.append("city", selectedCity.label);
    formData.append(
      "eventStartDate",
      state.eventStartDate != "Invalid date" &&
        state.eventStartDate != "" &&
        state.eventStartDate != null &&
        state.eventStartDate != undefined
        ? moment(state.eventStartDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
    );
    formData.append(
      "eventEndDate",
      state.eventEndDate != "Invalid date" &&
        state.eventEndDate != "" &&
        state.eventEndDate != null &&
        state.eventEndDate != undefined
        ? moment(state.eventEndDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
    );
    formData.append(
      "registrationStartDate",
      state.registrationStartDate != "Invalid date" &&
        state.registrationStartDate != "" &&
        state.registrationStartDate != null &&
        state.registrationStartDate != undefined
        ? moment(state.registrationStartDate).format("YYYY-MM-DD") +
        "T00:00:00.000Z"
        : "",
    );
    formData.append(
      "registrationEndDate",
      state.registrationEndDate != "Invalid date" &&
        state.registrationEndDate != "" &&
        state.registrationEndDate != null &&
        state.registrationEndDate != undefined
        ? moment(state.registrationEndDate).format("YYYY-MM-DD") +
        "T00:00:00.000Z"
        : "",
    );
    // formData.append(
    //   "eventStartTime",
    //   state.eventStartTime != "Invalid date" &&
    //     state.eventStartTime != "" &&
    //     state.eventStartTime != null &&
    //     state.eventStartTime != undefined
    //     ? moment(state.eventStartTime).format("HH:mm A")
    //     : "",
    // );
    formData.append(
      "eventStartTime",
      state.eventStartTime && state.eventStartTime !== "Invalid date"
        ? String(state.eventStartTime).includes("AM") ||
          String(state.eventStartTime).includes("PM")
          ? state.eventStartTime
          : moment(state.eventStartTime).format("HH:mm A")
        : "",
    );
    formData.append(
      "eventEndTime",
      state.eventEndTime && state.eventEndTime != "Invalid date"
        ? String(state.eventEndTime).includes("AM") ||
          String(state.eventEndTime).includes("PM")
          ? state.eventEndTime
          : moment(state.eventEndTime).format("HH:mm A")
        : "",
    );
    formData.append("countryDataCode", state.countryDataCode);
    formData.append("stateCode", state.stateCode);
    formData.append("districtCode", state.districtCode);
    formData.append("cityCode", state.cityCode);
    formData.append("maxRegistration", state.maxReg);
    formData.append("IsFreeEvent", true);
    formData.append(
      "RegistrationOpen",
      state.RegistrationOpen === true || state.RegistrationOpen === "true"
        ? "true"
        : "false",
    );

    formData.append("IsCanceledEvent", state.IsCanceledEvent);
    formData.append("MaxRegistration", state.MaxRegistration || 0);
    formData.append(
      "IsProfileCompleted",
      state.IsProfileCompleted ? "true" : "false",
    );

    if (bImage != null) {
      formData.append("eventBannerImage", bImage);
    }

    let urlPath = "event/create-event";
    try {
      fetch(url.VUF_APP_API + urlPath, {
        method: "POST",
        headers: {
          Authorization: "",
        },
        body: formData,
        redirect: "follow",
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.status) {
            if (id == null || id == "" || id == undefined) {
              toast.success("Event Successfully Added.");
            } else {
              toast.success("Event Successfully Updated.");
            }
            // navigate("/EventList");
          } else if (!responseData.status && "auth" in responseData) {
            // AuthController.Logout();
          } else if (!responseData.status && responseData.error) {
            toast.error(responseData?.error || "Error");
          } else {
            toast.error(
              "Something went wrong, Please try again after sometime.",
            );
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log("err", error);
          toast.error("Something went wrong, Please try again after sometime.");
        })
        .finally((final) => {
          // return setState({ isInvitingUser: false })
        });
    } catch (error) {
      console.error("Error uploading:", error);
    }
  };

  function onGetCountryList() {
    let urlPath = "auth/CountryList";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;
          let countries = [];
          countries.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (
              selectedCountry.label == c.country_name &&
              selectedCountry.value == 0
            ) {
              setSelectedCountry({ ...c, label: c.country_name, value: c.id });
              onGetStateList(c.id);
            }
            countries.push({ ...c, label: c.country_name, value: c.id });
          });
          const cot = [{ options: countries }];
          setCountries(cot);
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => { });
  }
  function onGetStateList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      countryDataCode: data,
    }));
    if (data != null && data != undefined && data != "") {
      let urlPath = "auth/StatesList/" + data;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: Body,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.status) {
            var data = responseData.response;
            let stateList = [];
            stateList.push({ label: "--Select--", value: "" });
            data.map((c, i) => {
              if (
                selectedState.label == c.state_title &&
                selectedState.value == 0
              ) {
                setSelectedState({
                  ...c,
                  label: c.state_title,
                  value: c.state_id,
                });
                onGetDistrictList(c.state_id);
              }
              stateList.push({ ...c, label: c.state_title, value: c.state_id });
            });
            const cot = [{ options: stateList }];
            setStateList(cot);
            // stateList.map((c)=>{
            //     if(state.state==c.label){
            //         setSelectedState(c)
            //         onGetDistrictList(c.value)
            //     }
            // })
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => { });
    }
  }
  function onGetDistrictList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      stateCode: data,
    }));

    let urlPath = "auth/DistrictsList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;
          let districtList = [];
          districtList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (
              selectedDistrict.label == c.district_title &&
              selectedDistrict.value == 0
            ) {
              setSelectedDistrict({
                ...c,
                label: c.district_title,
                value: c.districtid,
              });
              onGetCitiesList(c.districtid);
            }
            districtList.push({ label: c.district_title, value: c.districtid });
          });

          const cot = [{ options: districtList }];
          setDistrictList(cot);

          // districtList.map((c)=>{
          //     if(state.district==c.label){
          //         setSelectedDistrict(c)
          //         onGetCitiesList(c.value)
          //     }
          // })
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => { });
  }
  function onGetCitiesList(data) {
    setState((prevState) => ({
      ...prevState, // Copy the existing state
      districtCode: data, // Update only the `districtCode` property
    }));
    let urlPath = "auth/CitiesList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;
          let cityList = [];
          cityList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            if (selectedCity.label == c.name && selectedCity.value == 0) {
              setSelectedCity({ ...c, label: c.name, value: c.id });
            }
            cityList.push({ label: c.name, value: c.id });
          });

          const cot = [{ options: cityList }];
          setCityList(cot);
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => { });
  }

  function handleValidation() {
    let errors = {};
    let formIsValid = true;

    if (state.eventName?.trim() === "") {
      formIsValid = false;
      errors.eventName = "Please enter event Name";
    }
    if (state.location?.trim() === "") {
      formIsValid = false;
      errors.location = "Please enter location";
    }
    if (state.EventType?.trim() === "") {
      formIsValid = false;
      errors.EventType = "Please select event type";
    }
    if (state.eventBannerImage === "") {
      formIsValid = false;
      errors.eventBannerImage = "Please select event banner";
    }
    if (state.eventStartDate === "") {
      formIsValid = false;
      errors.eventStartDate = "Please enter start date";
    }
    if (state.eventEndDate === "") {
      formIsValid = false;
      errors.eventEndDate = "Please enter end date";
    }
    if (state.eventStartTime === "") {
      formIsValid = false;
      errors.eventStartTime = "Please enter start time";
    }
    if (state.eventEndTime === "") {
      formIsValid = false;
      errors.eventEndTime = "Please enter end time";
    }
    if (state.registrationStartDate === "") {
      formIsValid = false;
      errors.registrationStartDate = "Please select registration start date";
    }
    if (state.registrationEndDate === "") {
      formIsValid = false;
      errors.registrationEndDate = "Please select registration end date";
    }

    setState((prevState) => ({
      ...prevState, // Copy the existing state
      errors: errors,
    }));

    return formIsValid;
  }
  function onSelectLocation(e) {
    let location = e.value;
    setSelectedLocation(e);
    const foundItem = Locations[0].options.filter(
      (item) => item.value == location,
    )[0];
    setState((prevState) => ({
      ...prevState, // Copy the existing
      stateoptionalFieldAllow: foundItem?.optionalFieldAllow,
      country: foundItem.country,
      state: foundItem.state,
      location: location,
      district: foundItem.district,
      city: foundItem.city,
      cityCode: foundItem.cityCode,
      countryDataCode: foundItem.countryDataCode,
      districtCode: foundItem.districtCode,
      stateCode: foundItem.stateCode,
    }));
    setSelectedCountry({ label: foundItem.country, value: 0 });
    setSelectedState({ label: foundItem.state, value: 0 });
    setSelectedDistrict({ label: foundItem.district, value: 0 });
    setSelectedCity({ label: foundItem.city, value: 0 });

    countries[0].options.map((c) => {
      if (c.label == foundItem.country) {
        setSelectedCountry({ label: c.label, value: c.id });
        onGetStateList(c.value);
      }
    });
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <div
            className="container bg-white shadow rounded-5"
            style={{ maxWidth: "100%" }}
          >
            <h3 className="mb-4 border-bottom pb-3">
              {id ? `Edit Event - ${state.eventName}` : "Add Event"}
            </h3>
            <form>
              <div className="row g-3">
                <div className="col-md-3">
                  <div className="form-group">
                    <label className="form-label fw-bold">Event Name</label>
                    <Input
                      type="text"
                      name="eventName"
                      className="form-control form-control-solid"
                      placeholder="Enter event name"
                      onChange={(event) =>
                        setState((prevState) => ({
                          ...prevState,
                          eventName: event.target.value,
                        }))
                      }
                      value={state.eventName}
                    />
                    <span className="form-text text-danger">
                      {state.errors?.eventName}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label className="form-label fw-bold">Description</label>
                    <Input
                      type="text"
                      name="eventDescription"
                      className="form-control form-control-solid"
                      placeholder="Enter Description"
                      onChange={(event) =>
                        setState((prevState) => ({
                          ...prevState,
                          eventDescription: event.target.value,
                        }))
                      }
                      value={state.eventDescription}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Location</label>
                  <Select
                    value={selectedLocation}
                    onChange={(e) => {
                      onSelectLocation(e);
                    }}
                    options={Locations}
                    placeholder="Select Location"
                  />
                  <span className="form-text text-danger">
                    {state.errors?.location}
                  </span>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Event Type</label>
                  <select
                    id="eventType"
                    className="form-control"
                    value={state.EventType}
                    onChange={(e) => {
                      setState((prevState) => ({
                        ...prevState,
                        EventType: e.target.value,
                      }));
                    }}
                  >
                    <option value=" ">Select Event Type</option>
                    <option value="Public">Public</option>
                  </select>
                  <span className="form-text text-danger">
                    {state.errors?.EventType}
                  </span>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">Event Banner</label>
                  <div
                    className={`border border-2 rounded-3 d-flex flex-column align-items-center justify-content-center p-1 transition-all ${isDragging ? "bg-light" : ""
                      }`}
                    style={{
                      minHeight: "200px",
                      borderStyle: "dashed !important",
                      cursor: "pointer",
                      backgroundColor: isDragging ? "#dee2e6" : "transparent",
                    }}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => fileInputRef.current.click()}
                  >
                    {!imagePreview && !state.eventBannerImage ? (
                      <div className="text-center">
                        <i className="bi bi-cloud-arrow-up fs-1 text-secondary"></i>
                        <p className="mb-2 mt-2 text-muted">
                          Drag & Drop your image here
                        </p>
                        <small className="text-uppercase fw-bold text-primary">
                          or click to browse
                        </small>
                      </div>
                    ) : (
                      <div className="position-relative w-100 h-100">
                        <img
                          src={
                            imagePreview
                              ? imagePreview
                              : `${url.VUF_APP_BANNER_URL}${state.eventBannerImage}`
                          }
                          alt="Preview"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            maxHeight: "180px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                    <input
                      type="file"
                      name="eventBannerImage"
                      ref={fileInputRef}
                      className="d-none"
                      accept="image/*"
                      onChange={(e) => handleFile(e.target.files[0])}
                    />
                  </div>
                  <small className="text-muted mt-2 d-block">
                    Recommended size: 1200x600px (JPG, PNG, JPEG)
                  </small>
                  <span className="form-text text-danger">
                    {state.errors?.eventBannerImage}
                  </span>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label className="form-label fw-bold">Country</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedCountry}
                        isDisabled={true}
                        onChange={(e) => {
                          setSelectedCountry(e);
                          setSelectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setSelectedCity({
                            label: "--Select--",
                            value: "",
                          });
                          setSelectedState({
                            label: "--Select--",
                            value: "",
                          });
                          onGetStateList(e.value);
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#fff", // keep white
                            cursor: "default", // normal cursor
                            color: "black",
                            opacity: 1, // prevent gray-out
                            pointerEvents: "none", // no interaction
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "black",
                          }),
                        }}
                        options={countries}
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label className="form-label fw-bold">State</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedState}
                        isDisabled={true}
                        onChange={(e) => {
                          setSelectedState(e);
                          setSelectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setSelectedCity({
                            label: "--Select--",
                            value: "",
                          });
                          onGetDistrictList(e.value);
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#fff",
                            cursor: "default",
                            color: "black",
                            opacity: 1,
                            pointerEvents: "none",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "black",
                            border: "black",
                          }),
                        }}
                        options={stateList}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">District</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedDistrict}
                        isDisabled={true}
                        onChange={(e) => {
                          setSelectedDistrict(e);
                          setSelectedCity({
                            label: "--Select--",
                            value: "",
                          });
                          onGetCitiesList(e.value);
                        }}
                        options={districtList}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#fff", // keep white
                            cursor: "default", // normal cursor
                            color: "black",
                            opacity: 1, // prevent gray-out
                            pointerEvents: "none", // no interaction
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "black",
                            border: "black",
                          }),
                        }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">City</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedCity}
                        onChange={(e) => {
                          setSelectedCity(e);
                        }}
                        options={cityList}
                        isDisabled={true}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: "#fff",
                            cursor: "default",
                            color: "black",
                            opacity: 1,
                            pointerEvents: "none",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: "black",
                            border: "black",
                          }),
                        }}
                      />
                      <span className="form-text text-danger">
                        {state.errors?.selectedCity}
                      </span>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Start Date</label>
                      <Flatpickr
                        value={state.eventStartDate
                          ? new Date(state.eventStartDate)
                          : null}
                        onChange={(selectedDates) => {
                          const newStartDate = selectedDates[0];
                          setState((prevState) => ({
                            ...prevState,
                            eventStartDate: newStartDate,
                            eventEndDate:
                              prevState.eventEndDate &&
                                prevState.eventEndDate < newStartDate
                                ? null
                                : prevState.eventEndDate,
                          }));
                        }}
                        options={{
                          minDate: state.eventStartDate || "today",
                          dateFormat: "Y-m-d",
                        }}
                        className="form-control"
                        placeholder="Select Start Date"
                      />
                      <span className="form-text text-danger">
                        {state.errors?.eventStartDate}
                      </span>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">End Date</label>
                      <Flatpickr
                        value={state.eventEndDate}
                        onChange={(selectedDates) => {
                          setState((prevState) => ({
                            ...prevState,
                            eventEndDate: selectedDates[0],
                          }));
                        }}
                        options={{
                          minDate: state.eventStartDate || "today",
                          dateFormat: "Y-m-d",
                        }}
                        className="form-control"
                        placeholder="Select End Date"
                        disabled={!state.eventStartDate}
                      />
                      <span className="form-text text-danger">
                        {state.errors?.eventEndDate}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-3">
                <div className="col-md-3 mb-3">
                  <label className="form-label fw-bold">Start Time</label>
                  <Flatpickr
                    onChange={(selectedDates) => {
                      setState((prevState) => ({
                        ...prevState,
                        eventStartTime: selectedDates[0],
                      }));
                    }}
                    value={
                      typeof state.eventStartTime === "string"
                        ? moment(state.eventStartTime, "HH:mm A").toDate()
                        : state.eventStartTime
                    }
                    options={{
                      enableTime: true,
                      noCalendar: true,
                      dateFormat: "h:i K",
                    }}
                    className="form-control"
                    placeholder="Select Time"
                  />
                  <span className="form-text text-danger">
                    {state.errors?.eventStartTime}
                  </span>
                </div>

                <div className="col-md-3">
                  <label className="form-label fw-bold">End Time</label>
                  <Flatpickr
                    value={
                      typeof state.eventEndTime === "string"
                        ? moment(state.eventEndTime, "HH:mm A").toDate()
                        : state.eventEndTime
                    }
                    onChange={(selectedDates) => {
                      setState((prevState) => ({
                        ...prevState,
                        eventEndTime: selectedDates[0],
                      }));
                    }}
                    options={{
                      enableTime: true,
                      noCalendar: true,
                      dateFormat: "h:i K",
                    }}
                    className="form-control"
                    placeholder="Select Time"
                  />
                  <span className="form-text text-danger">
                    {state.errors?.eventEndTime}
                  </span>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">
                    Registration Start
                  </label>
                  <Flatpickr
                    value={state.registrationStartDate}
                    onChange={(selectedDates) => {
                      const newStartDate = selectedDates[0];
                      setState((prevState) => ({
                        ...prevState,
                        registrationStartDate: newStartDate,
                        registrationEndDate:
                          prevState.registrationEndDate &&
                            prevState.registrationEndDate < newStartDate
                            ? null
                            : prevState.registrationEndDate,
                      }));
                    }}
                    options={{
                      minDate: state.eventStartDate ? null : "today",
                      dateFormat: "Y-m-d",
                    }}
                    className="form-control"
                    placeholder="Select Registration Start Date"
                  />
                  <span className="form-text text-danger">
                    {state.errors?.registrationStartDate}
                  </span>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Registration End</label>
                  <Flatpickr
                    value={state.registrationEndDate}
                    onChange={(selectedDates) => {
                      setState((prevState) => ({
                        ...prevState,
                        registrationEndDate: selectedDates[0],
                      }));
                    }}
                    options={{
                      minDate: state.registrationStartDate || "today",
                      dateFormat: "Y-m-d",
                    }}
                    className="form-control"
                    placeholder="Select Registration End Date"
                    disabled={!state.registrationStartDate}
                  />
                  <span className="form-text text-danger">
                    {state.errors?.registrationEndDate}
                  </span>
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Max Registration</label>
                  <Input
                    type="number"
                    name="MaxRegistration"
                    className="form-control form-control-solid"
                    onChange={(event) => {
                      setState((prevState) => ({
                        ...prevState,
                        MaxRegistration: event.target.value,
                      }));
                    }}
                    value={state.MaxRegistration}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">
                    Registration Open
                  </label>
                  <Select
                    name="RegistrationOpen"
                    options={StatusOptions}
                    value={StatusOptions.find(
                      (option) => option.value === state.RegistrationOpen,
                    )}
                    onChange={(val) => {
                      setState((prev) => ({
                        ...prev,
                        RegistrationOpen: val ? val.value : "",
                      }));
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label fw-bold">Is Cancel?</label>
                  <Select
                    name="isCanceled"
                    options={EventOptions}
                    value={EventOptions.find(
                      (option) => option.value === state.IsCanceledEvent,
                    )}
                    onChange={(val) => {
                      setState((prev) => ({
                        ...prev,
                        IsCanceledEvent: val ? val.value : "",
                      }));
                    }}
                  />
                </div>
                {/* <div className="col-md-3">
                  <label className="form-label fw-bold">
                    Is this event free to attend?
                  </label>
                  <Select
                    name="IsEventFree"
                    options={EventOptions}
                    value={EventOptions.find(
                      (option) => option.value === state.IsEventFree,
                    )}
                    onChange={(val) => {
                      setState((prev) => ({
                        ...prev,
                        IsEventFree: val ? val.value : "",
                      }));
                    }}
                  />
                </div> */}
              </div>

              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-outline-primary me-3"
                  onClick={(event) => handleSubmit(event)}
                >
                  {id == "" || id == null || id == undefined
                    ? "Add Event"
                    : "Update Event"}
                </button>
                <Link to={"/EventList"} className="btn btn-outline-danger">
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Event);
